var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2372",
    "data-name": "Group 2372",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.099,
    height: 21.057,
    viewBox: "0 0 19.099 21.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_735",
    "data-name": "Rectangle 735",
    width: 19.099,
    height: 21.057,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2371",
    "data-name": "Group 2371",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M1.784,0A6.588,6.588,0,0,1,2.8.411q7.655,4.662,15.3,9.346a1.79,1.79,0,0,1-.57,3.38c-.3.057-.593.119-.889.179-1.63.329-3.261.652-4.887,1a.626.626,0,0,0-.361.317c-.855,1.772-1.69,3.553-2.541,5.326a1.768,1.768,0,0,1-2.266.976,1.843,1.843,0,0,1-1.1-1.276c-.577-1.866-1.166-3.728-1.751-5.591Q1.931,8.326.126,2.587A1.777,1.777,0,0,1,1.3.125,3.538,3.538,0,0,1,1.751.062ZM15.992,11.132,2.588,2.939l4.7,14.972c.091-.182.139-.273.183-.366C8.195,16.032,8.921,14.522,9.633,13a1.3,1.3,0,0,1,.993-.787c.617-.115,1.232-.244,1.848-.369l3.518-.716",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMove);
export default __webpack_public_path__ + "static/media/icon_move.eb3f2d0273624138a09049ddb862a382.svg";
export { ForwardRef as ReactComponent };